<template lang="pug">
div
  UiCardSection
    UiStack
      UiStackItem(fill)
        .ui-card-section-title {{ $t("companies.tabs.users") }}
      UiStackItem
        UiButton(
          @click="inviteNewUser"
          icon="Plus"
        ) {{ $t("companies.users.invite_new_user") }}
  UiCardSection
    RestTable(
      namespace="company_users"
      :headers="headers"
      ref="companyUsersTable"
      :fetch-handler="getData"
      embed
    )
      template(#cell:actions="{ item }")
        UiStack(spacing="xs")
          UiStackItem
            UiButton(
              size="sm"
              variant="smooth-primary"
              @click="editUser(item)"
              icon="PencilCreate"
            ) {{ $t("actions.edit") }}
          UiStackItem
            UiButton(
              size="sm"
              variant="smooth-danger"
              @click="deleteUser(item)"
              icon="Trash"
            ) {{ $t("actions.delete") }}
  EditUserModal(
    ref="EditUserModal"
    @done="reloadList"
  )
</template>

<script>
import router from "@/router";
import ApiCompanyUsers from "@/api/companyUsers.js";
import EditUserModal from "@/modals/Companies/editUser.vue";

export default {
  components: {
    EditUserModal,
  },

  data() {
    return {
      headers: [
        {
          key: "id",
          label: "#",
          sortable: true,
          squeeze: true,
        },
        {
          key: "name",
          label: "Name",
          sortable: true,
        },
        {
          key: "email",
          label: "email",
          sortable: true,
        },
        {
          key: "role",
          label: "role",
          sortable: true,
        },
        {
          key: "actions",
          label: "",
          squeeze: true,
        },
      ],
    };
  },

  methods: {
    reloadList() {
      this.$refs.companyUsersTable.fetchData();
    },
    getData(params, config) {
      return ApiCompanyUsers.fetchUsers(
        this.$route.params.id,
        params,
        config,
      ).then((resp) => {
        return {
          items: resp.data.users,
          meta: resp.data.meta,
        };
      });
    },

    editUser(item) {
      this.$refs.EditUserModal.open(this.$route.params.id, item);
    },

    deleteUser(item) {
      this.$dialogConfirm({
        title: this.$t("actions.remove"),
        description: this.$t("actions.confirm_remove"),
        variant: "danger",
        icon: "account-minus",
        okLabel: this.$t("actions.remove"),
        okVariant: "danger",
        okIcon: "Trash",
        cancelVariant: "smooth-secondary",
      }).then((result) => {
        if (!result) return;
        ApiCompanyUsers.deleteUser(this.$route.params.id, item.id).then(
          (resp) => {
            this.reloadList();
          },
        );
      });
    },

    inviteNewUser() {
      this.$refs.EditUserModal.open(this.$route.params.id, null);
    },

    goBack() {
      router.push("/companies");
    },
  },
};
</script>
